import React, { useEffect } from 'react'
import { useWatchableRef } from 'lib/hooks'

import ExpandableText from '../ExpandableText'
import { Portal } from 'components/utility/portal'

export default function LegalDisclaimerModal({ open, onClose }) {
  const modalRef = useWatchableRef(null)

  useEffect(() => {
    if (!modalRef.current) return

    const handleClose = (_e) => onClose()
    const localRefValue = modalRef.current

    $(localRefValue).on('hidden.bs.modal', handleClose)

    return () => $(localRefValue).off('hidden.bs.modal', handleClose)
  }, [onClose, modalRef.version])

  useEffect(() => {
    if (!modalRef.current) return

    if (open) {
      $(modalRef.current).modal('show')
    } else {
      $(modalRef.current).modal('hide')
    }
  }, [open, modalRef.version])

  return (
    <Portal>
      <div ref={modalRef.ref} className="modal fade legal-disclaimer-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content new-brp-modal">
            <div className="modal-header">
              <div className="dome-h2 dome-color-dark-green">legal disclaimer</div>
            </div>
            <div className="modal-body">
              <div className="dome-p2">
                <ExpandableText maxLines={null} />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="dome-btn dome-btn-link dome-btn-link-cancel pull-left dome-color-med-grey"
                data-dismiss="modal"
                onClick={onClose}
              >
                close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}
